import React, { Fragment } from "react"
import { connect } from 'react-redux';

import {
  PieChart,
  Pie,
  Tooltip,
  Cell,
  ResponsiveContainer
} from "recharts"

import {
  selectFormat,
  StandardTooltip,
  ComponentWithUrl,
  MAIN_COLORS
} from "./../Utils/Utils.js"

import Loader from './../Loader/Loader.js';

// const COLORS =
// {
//   "Telemundo": [
//     { "brand": "Telemundo", "color": '#1F85C6' },
//     { "network": "Facebook", "color": '#65E1F1' },
//     { "network": "Instagram", "color": '#2AC8DC' },
//     { "network": "Twitter", "color": '#1B8D9C' },
//     { "network": "YouTube", "color": '#18656E' }
//   ],
//   "RSN": [
//     { "brand": "RSN", "color": '#FC2C45' },
//     { "network": "Facebook", "color": '#F87A89' },
//     { "network": "Instagram", "color": '#E16C7A' },
//     { "network": "Twitter", "color": '#C75E6A' },
//     { "network": "YouTube", "color": '#92464F' }
//   ],
//   "Sports": [
//     { "brand": "Sports", "color": '#21AA68' },
//     { "network": "Facebook", "color": '#2CDC88' },
//     { "network": "Instagram", "color": '#30C57C' },
//     { "network": "Twitter", "color": '#1B8C57' },
//     { "network": "YouTube", "color": '#156A42' }
//   ],
//   "News": [
//     { "brand": "News", "color": "#F01F8E" },
//     { "network": "Facebook", "color": '#F5A5D1' },
//     { "network": "Instagram", "color": '#F492C8' },
//     { "network": "Twitter", "color": '#F466B3' },
//     { "network": "YouTube", "color": '#F846A6' }
//   ],
//   "nbc_e_facebook": [
//     { "brand": "News", "color": "#F01F8E" },
//     { "network": "Facebook", "color": '#F5A5D1' },
//     { "network": "Instagram", "color": '#F492C8' },
//     { "network": "Twitter", "color": '#F466B3' },
//     { "network": "YouTube", "color": '#F846A6' }
//   ],
//   "bravo_facebook": [
//     { "brand": "News", "color": "#F01F8E" },
//     { "network": "Facebook", "color": '#F5A5D1' },
//     { "network": "Instagram", "color": '#F492C8' },
//     { "network": "Twitter", "color": '#F466B3' },
//     { "network": "YouTube", "color": '#F846A6' }
//   ],
//     "nbc_golf_facebook": [
//     { "brand": "News", "color": "#F01F8E" },
//     { "network": "Facebook", "color": '#F5A5D1' },
//     { "network": "Instagram", "color": '#F492C8' },
//     { "network": "Twitter", "color": '#F466B3' },
//     { "network": "YouTube", "color": '#F846A6' }
//   ],
//   "fandango_facebook": [
//     { "brand": "News", "color": "#F01F8E" },
//     { "network": "Facebook", "color": '#F5A5D1' },
//     { "network": "Instagram", "color": '#F492C8' },
//     { "network": "Twitter", "color": '#F466B3' },
//     { "network": "YouTube", "color": '#F846A6' }
//   ]
// }


class FollowersByBrand extends ComponentWithUrl {

  renderBrands = data => (
    <div className="row">
      {
        data.data2.map((property, index) => {
          return (
            <div className="col-6 col-md-4 mb-5 mt-4 mt-md-0 ml-0 ml-md-3" key={index}>
              <div className="list__item--header">
                <span className="list__key--header">
                  <span className="list__icon" style={{ 'background': MAIN_COLORS[index % MAIN_COLORS.length] }}></span>
                  {property.name}

                </span>
                <span className="list__value">
                  {selectFormat('number', data.data1.find(obj => obj.name === property.name).value)}
                </span>
              </div>
              {property.value.map((brand, j) => {
                if (brand.value > 0) {
                  return (
                    <div className="list__item ml-3" key={j}>
                      <span className="list__key">
                        <span className="list__icon" style={{ 'background': MAIN_COLORS[j % MAIN_COLORS.length] }}></span>
                        {brand.name}
                      </span>
                      <span className="list__value">
                        {selectFormat('number', brand.value)}
                      </span>
                    </div>
                  )
                } else {
                  return null
                }
              })

              }
            </div>
          )
        })
      }
    </div>
  )

  renderCell = (entry, index) => (
    <Cell key={index} fill={entry.fill} />
  )

  renderCellInner = (entry, index) => (
    <Cell key={index} fill={MAIN_COLORS[index % MAIN_COLORS.length]} label />
  )

  render() {

    const { loading, data } = this.props;
    const pie_chart_outer_data = []

    if (loading) {
      return (<Loader minHeight={400} col={'col-12 col-md-6'} />);
    }

    data.data2.map(a => (
      a.value.map((b, index) => {
        return pie_chart_outer_data.push(
          Object.assign(b, { "fill": MAIN_COLORS[index % MAIN_COLORS.length] })
        )
      })
    ))

    pie_chart_outer_data.sort((a, b) => b.value - b.value)

    return (
      <div className="row">
        <div className="col-12 col-md-4">
          <div style={{ height: '320px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart margin={{ top: 5, right: 5, bottom: 5, left: 5 }} >
                <Pie
                  data={data.data1}
                  dataKey="value"
                  innerRadius="55%"
                  outerRadius="100%"
                // label
                // labelLine
                // label={<CustomizedPieLabel />}
                // labelLine={false}
                >
                  {data.data1.map(this.renderCellInner)}
                </Pie>

                {/* <Pie
                  data={pie_chart_outer_data}
                  dataKey="value"
                  innerRadius="85%"
                  outerRadius="100%"
                // label={<CustomizedPieLabel />}
                // labelLine={false}
                >
                  {pie_chart_outer_data.map(this.renderCell)}
                </Pie> */}


                <Tooltip cursor={{ fill: "#eee", opacity: .5 }} content={
                  <StandardTooltip data={data}
                    render={({ data }) => {
                      const payload = data(data)

                      if (payload !== null) {
                        const total = this.props.data.data1.reduce((s, e) => s + e.value, 0)
                        return (
                          <div className="standard-tooltip">

                            <main className="standard-tooltip__main">
                              {
                                Object.keys(payload)
                                  .sort((a, b) => payload[b].value - payload[a].value)
                                  .filter((key) => payload[key].value > 0)
                                  .map(key => (
                                    <Fragment key={key}>
                                      <div className="standard-tooltip__item">
                                        <span className="standard-tooltip__key" style={{ color: payload[key].payload.fill }}>
                                          <span className="standard-tooltip__icon" style={{ "background": payload[key].payload.fill }}></span>
                                          {payload[key].payload.name}
                                        </span>
                                        <span className="standard-tooltip__value">
                                          {selectFormat('number', payload[key].value)} {''}
                                          ({(payload[key].value * 100 / total).toFixed(0)}%)
                                        </span>
                                      </div>
                                    </Fragment>
                                  ))}
                              {
                                this.props.data.data2.find(o => o.name === payload[0].name).value.map((item, key) => (
                                  <div className="list__item ml-3" key={key}>
                                    <span className="list__key">
                                      <span className="list__icon" style={{ 'background': MAIN_COLORS[key % MAIN_COLORS.length] }}></span>
                                      {item.name}
                                    </span>
                                    <span className="list__value">
                                      {selectFormat('number', item.value)}
                                    </span>
                                  </div>
                                ))
                              }
                            </main>
                          </div>
                        )
                      }
                    }} />
                } />

              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="col-12 col-md-8">
          {this.renderBrands(data)}
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true
  };
};

export default connect(mapStateToProps)(FollowersByBrand);